import React,{Component} from 'react';
import './App.css';
import ReactGA from 'react-ga';
import Header from './Components/Header';
import About from './Components/About';
import Footer from './Components/Footer';
import Resume from './Components/Resume';
import Interests from './Components/Interests';
import Work from './Components/Work';
import Bachelor from './Components/Bachelor';
import { trackPromise } from 'react-promise-tracker';
import { dataAPI } from './api/data';

class App extends Component {
  

 constructor(props){
   super(props);
   this.handler = this.handler.bind(this)

   this.state={
     cvdata:[],
     isGerman:false
   }
   ReactGA.initialize('UA-110570651-1');
   ReactGA.pageview(window.location.pathname);
 }

 handler() {
  this.setState({
    isGerman: !(this.state.isGerman)
  })
}


componentDidMount(){
  trackPromise(
    dataAPI.fetchData()
      .then((cvdata) => {
        this.setState({
          cvdata
        })
      })
  );
    
}
  render (){

    return (
          <div className="App">
              <Header       data={this.state.isGerman ? this.state.cvdata.german : this.state.cvdata.english}
                            handler = {this.handler} isGerman ={this.state.isGerman} />
              <About        data={this.state.isGerman ? this.state.cvdata.german : this.state.cvdata.english}
                            isGerman ={this.state.isGerman} />
              <Resume       data={this.state.isGerman ? this.state.cvdata.german : this.state.cvdata.english}
                            isGerman ={this.state.isGerman} />
              <Interests    data={this.state.isGerman ? this.state.cvdata.german : this.state.cvdata.english}
                            isGerman ={this.state.isGerman} />
              <Work         data={this.state.isGerman ? this.state.cvdata.german : this.state.cvdata.english}
                            isGerman ={this.state.isGerman} />
              <Bachelor     data={this.state.isGerman ? this.state.cvdata.german : this.state.cvdata.english}
                            isGerman ={this.state.isGerman}/>
              <Footer       data={this.state.isGerman ? this.state.cvdata.german : this.state.cvdata.english}
                            isGerman ={this.state.isGerman} />
          </div>
    );
  }
}

export default App;
